import { FC } from 'react';

import { Sync as SyncIcon } from '@mui/icons-material';
import { IUploadSectionLoaderProps } from './types';
import { UploadSection } from './Section';

export const UploadSectionLoader: FC<IUploadSectionLoaderProps> = (props) => {
  const { data, children, defaultExpanded = true } = props;

  return (
    <UploadSection
      defaultExpanded={defaultExpanded}
      header={
        <div className='flex items-center gap-16'>
          <div className='w-[28px] h-[28px] rounded-full bg-[#EBEEF0] border border-[#597282] flex items-center justify-center'>
            <SyncIcon className='text-[#A3A3A3] animate-spin-reverse' sx={{ fontSize: '22px' }} />
          </div>
          <div className='flex items-center gap-8'>
            <div className='flex-1 text-16 font-medium text-neutral-70'>Loading / Processing</div>
            {data?.length && (
              <>
                <div className='w-4 h-4 bg-blue_grey-30 rounded-full' />
                <div className='text-12 xl:text-14 font-bold'>{data.length} items</div>
              </>
            )}
          </div>
        </div>
      }
    >
      {children}
    </UploadSection>
  );
};
